import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'castdate' })
export class CastDatePipe implements PipeTransform {
  transform(n: any): Date { return n as Date; }
}
